/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  autoBatchEnhancer,
  combineReducers,
  configureStore,
  ConfigureStoreOptions,
  Middleware,
} from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from '../rootEpic.ts';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const createMiddleware =
  (otherMiddleware: Middleware[]) => (getDefaultMiddleware: CurriedGetDefaultMiddleware<any>) => {
    let middleware: any = getDefaultMiddleware();

    otherMiddleware.forEach((m) => {
      middleware = middleware.concat(m);
    });

    return middleware;
  };

export const createStore = (
  reducers: any,
  middleware: Middleware[],
  options?: ConfigureStoreOptions['preloadedState'] | undefined,
) => {
  reducers = combineReducers(reducers);

  const epicMiddleware = createEpicMiddleware();
  const store = configureStore({
    reducer: reducers,
    devTools: true,
    middleware: createMiddleware([epicMiddleware, ...middleware]),
    enhancers: (existingEnhancers) => {
      return existingEnhancers.concat(autoBatchEnhancer(), sentryReduxEnhancer);
    },
    ...options,
  });

  epicMiddleware.run(rootEpic);

  return {
    store,
  };
};
